export default __webpack_public_path__ + "static/media/kaizenSmall.4c234fa5.jpg";